<template>
  <div class="print-break-after">
    <!-- ORDINE PRINCIPALE -->
    <div class="wg-row" v-if="this.project.category && (this.project.category == 2)">
      <div class="wg-col wg-xs-12">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Main order', 'Ordine originale') }}</div>
          <input
            v-if="mode === 'view'"
            :disabled="true"
            class="input-elem com-anm22-app-input-date print-row"
            type="text"
            placeholder="VRS MAR ROS 23 001"
            v-model="formData.mainProject"
          />
          <div v-else>
            <wg-search
                v-if="!(formData.mainProject && formData.mainProject != '')"
                :placeholder="formData.mainProject ? formData.mainProject : 'VRS MAR ROS 23 001'"
                :url="'vircos/searchProject'"
                :clickFn="selectMainProject"
                :canAdd="false"
                :attachedData="{projectId: project.idWorldProject}"
                :debounceTime="1000"
              ></wg-search>
            <div
              v-else
              class="selected-main-project"><div>{{ formData.mainProject }}</div><img :src="this.$anm22.icons.getWorldIcon('deleteBlack')" @click="removeMainProject" /></div>
          </div>
        </div>
      </div>
    </div>
    <!-- DATA ORDINE -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Order date', 'Data ordine') }}</div>
          <input
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-input-date print-row"
            type="date"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
            v-model="orderDate"
          />
        </div>
      </div>
      <!-- LUOGO ORDINE -->
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Place', 'Luogo ordine') }}</div>
          <input
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Place', 'Luogo')"
            v-model="formData.orderPlace"
          />
        </div>
      </div>
    </div>
    <!-- Nel caso non sia ancora settato un customer, Nome e Cognome sono dei wg-search particolari per l'aggiunta rapida -->
    <!-- NOME-->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
          <input
            ref="customer_firstName"
            :disabled="mode === 'view'"
            v-if="project.customers.length > 0 || newContactMode || mode === 'view'"
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
            v-model="customer.firstName"
          />
          <div v-else class="input-elem print-row">
            <wg-search
              :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
              :url="'vircos/searchContacts'"
              :clickFn="selectContact"
              :canAdd="true"
              :addFn="(val) => setNewContactMode('firstName', val)"
              :attachedData="{projectId: project.idWorldProject}"
              :debounceTime="2000"
            ></wg-search>
          </div>
        </div>
      </div>
      <!-- COGNOME -->
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Last name', 'Cognome') }}</div>
          <input
            ref="customer_lastName"
            :disabled="mode === 'view'"
            v-if="project.customers.length > 0 || newContactMode || mode === 'view'"
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Last name', 'Cognome')"
            v-model="customer.lastName"
          />
          <div v-else class="input-elem print-row">
            <wg-search
              :placeholder="$anm22.strLang(lang, 'Last name', 'Cognome')"
              :url="'vircos/searchContacts'"
              :clickFn="selectContact"
              :canAdd="true"
              :addFn="(val) => setNewContactMode('firstName', val)"
              :attachedData="{projectId: project.idWorldProject}"
              :debounceTime="2000"
            ></wg-search>
          </div>
        </div>
      </div>
    </div>
    <!-- INDIRIZZO -->
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row" style="padding:5px;">
      <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Address', 'Indirizzo') }}</div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Street', 'Via') }}</div>
          <div class="wg-row input-elem print-row" style="aling-items:center;">
            <input
              :disabled="mode === 'view'"
              class="com-anm22-app-input-text row-add"
              style="width:155px;"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
              v-model="address.addressStreet"
            />
            <input
              :disabled="mode === 'view'"
              class="com-anm22-app-input-text row-numb"
              style="width:40px;margin-left:5px;"
              type="text"
              placeholder="N."
              v-model="address.addressNumber"
            />
          </div>
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'City', 'Città') }}</div>
          <input
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            :placeholder="$anm22.strLang(lang, 'City', 'Città')"
            v-model="address.addressCity"
          />
        </div>
      </div>
    </div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'ZIP', 'CAP') }}</div>
          <input
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
            v-model="address.addressZip"
          />
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'State', 'Provincia') }}</div>
          <input
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
            v-model="address.addressState"
          />
        </div>
      </div>
    </div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Country', 'Paese') }}</div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select print-row"
            v-model="addressCountry"
          >
            <option value selected disabled hidden>{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
            <option
              v-for="(obj,key,index) in $anm22.tableClasses.worldCountry().getAll()"
              :key="'country-'+index"
              :value="key"
            >{{ obj[lang] }}</option>
          </select>
          <input
            v-else
            disabled
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            v-model="$anm22.tableClasses.worldCountry().getById(addressCountry)[lang]"
          />
        </div>
      </div>
    </div>
    <!-- TELEFONO -->
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row" style="padding:5px;">
      <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Phone', 'Telefono') }}</div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Area code', 'Prefisso') }}</div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select print-row"
            v-model="phoneAreaCode"
          >
            <option value selected disabled hidden>{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
            <option
              v-for="(obj,key,index) in $anm22.tableClasses.areaCode().getAll()"
              :key="'areaCode-'+index"
              :value="key"
            >{{ obj[lang] }}</option>
          </select>
          <input
            v-else
            disabled
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            v-model="$anm22.tableClasses.areaCode().getById(phoneAreaCode)[lang]"
          />
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Number', 'Numero') }}</div>
          <input
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
            v-model="customer.phoneNumber"
          />
        </div>
      </div>
    </div>
    <!-- E-MAIL -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ 'E-mail' }}</div>
          <input
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-input-text print-row"
            type="text"
            :placeholder="'E-mail'"
            v-model="customer.email"
          />
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="wg-col wg-xs-12">
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, 'Commercial policy', 'Policy commerciale') }}</div>
          </div>
          <div :class="['wg-col', 'wg-xs-3']" style="text-align:right">
            <input
              :disabled="mode === 'view'"
              id="treatment"
              type="checkbox"
              :value="1"
              style="display:none;"
              v-model="customer.commercialPrivacyPolicyDate"
            />
            <label class="label-input-radio" style="display:inline-block" for="treatment">{{ customer.commercialPrivacyPolicyDate ? '✔' : '' }}</label>
          </div>
        </div>
      </div>
    </div>
    <!-- COMMITTENTE (VIRCOS/ALTRI) -->
    <div class="wg-row company-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Company', 'Azienda') }}</div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.company"
          >
            <option v-for="(c,i) in companies" :key="'comp-'+i" :value="c.id">{{ c.label }}</option>
            <option value="others">{{ $anm22.strLang(lang, 'Others', 'Altri') }}</option>
          </select>
          <div v-else class="com-anm22-app-text-m">
            {{
            formData.company === 'others'
            ? formData.companyName + ' - ' + formData.pilot
            : companies.find(c => c.id === formData.company).label
            }}
          </div>
        </div>
      </div>
    </div>
    <!-- NEL CASO "ALTRI" INSERIRE NOME -->
    <template v-if="mode === 'edit'">
      <div v-if="formData.company === 'others'" class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
            <input
              class="input-elem com-anm22-app-input-text print-row"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
              v-model="formData.companyName"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Pilot', 'Pilota') }}</div>
            <input
              class="input-elem com-anm22-app-input-text print-row"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Pilot name', 'Nome pilota')"
              v-model="formData.pilot"
            />
          </div>
        </div>
      </div>
      <!-- CLIENTE / SPONSOR -->
      <div v-if="formData.company === 'vircos'" class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div
            v-if="formData.company === 'vircos'"
            class="wg-row input-row print-row"
            style="height:36px;"
          >
            <div class="com-anm22-app-text-m">Sponsor</div>
            <div class="wg-row" style="align-items:center;max-width:200px;">
              <input
                :disabled="mode === 'view'"
                id="sponsor-yes"
                type="radio"
                :value="1"
                style="display:none;"
                v-model="formData.sponsor"
              />
              <label
                class="label-input-radio"
                for="sponsor-yes"
              >{{ formData.sponsor === 1 ? '✔' : '' }}</label>
              <div
                class="com-anm22-app-text-m"
                style="margin:0 5px;"
              >{{ $anm22.strLang(lang, 'Yes', 'Sì') }}</div>
              <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
              <input
                :disabled="mode === 'view'"
                id="sponsor-no"
                type="radio"
                :value="0"
                style="display:none;"
                v-model="formData.sponsor"
              />
              <label
                class="label-input-radio"
                for="sponsor-no"
              >{{ formData.sponsor === 0 ? '✔' : '' }}</label>
              <div
                class="com-anm22-app-text-m"
                style="margin:0 5px;"
              >{{ $anm22.strLang(lang, 'No', 'No') }}</div>
            </div>
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
      </div>
    </template>
    <!-- CANALE ACQUISIZIONE -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Lead channel', 'Canale acquisizione') }}</div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="formData.channel"
          >
            <option v-for="(c,i) in channels" :key="'comp-'+i" :value="c.id">{{ c.label }}</option>
          </select>
          <div v-else class="com-anm22-app-text-m">
            {{
            formData.channel
            ? channels.find(c => c.id === formData.channel).label
            : $anm22.strLang(lang, 'ND', 'ND')
            }}
          </div>
        </div>
      </div>
    </div>
    <!-- NOTE -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Notes', 'Note') }}</div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <textarea
          :disabled="mode === 'view'"
          class="input-elem com-anm22-app-textarea print-row"
          style="height:100px;width:100%;max-width:unset;"
          v-model.lazy="formData.notes"
        ></textarea>
      </div>
    </div>
    <!-- INVIO NOTIFICHE -->
    <div v-if="formData.company == 'vrs' || formData.company == 'rvt'" class="wg-row input-row no-print">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Welcome email', 'Email di benvenuto') }}</div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div v-if="notificationSended || formData.notificationWelcome" class="wg-col wg-xs-12 wg-sm-6">
        <div class="vircos-notification-sended">
          <img :src="$anm22.icons.getWorldIcon('check')" />
          {{ $anm22.strLang(lang, 'Sended', 'Inviata') }} {{ $moment.unix(formData.notificationWelcome).format("DD/MM/YYYY HH:mm") }}
        </div>
      </div>
      <div v-else class="wg-col wg-xs-12 wg-sm-6">
        <div @click="sendWelcomeNotification()" class="vircos-notification-send-btn">
          <img :src="$anm22.icons.getWorldIcon('send')" />
          {{ $anm22.strLang(lang, 'Send', 'Invia') }}
        </div>
      </div>
    </div>
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Last edit', 'Ultima modifica') }}</div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">{{ lastEditDate + ' ' + lastEditUser }}</div>
      </div>
    </div>
    <template v-if="mode === 'edit'">
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <input type="button" :value="$anm22.strLang(lang, 'Save', 'Salva')" @click="saveContact" />
      </div>
    </template>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    mode: {
      type: String,
      default: "edit"
    }
  },
  data() {
    return {
      newContactMode: false,
      customer: {},
      address: {},
      formData: {},
      notificationSended: false,
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    orderDate: {
      get() {
        if (this.formData.orderDate) {
          return this.$moment
            .unix(this.formData.orderDate)
            .format("YYYY-MM-DD");
        } else {
          return this.$moment().format("YYYY-MM-DD");
        }
      },
      set(newDate) {
        let ts = Number(
          this.$moment(newDate)
            .utc()
            .format("X")
        );
        if (isNaN(ts)) {
          this.$set(this.formData, "orderDate", "");
        } else if (ts) {
          this.$set(this.formData, "orderDate", ts);
        }
      }
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    addressCountry: {
      get() {
        return this.address.addressCountry ? this.address.addressCountry : "";
      },
      set(newVal) {
        this.$set(this.address, "addressCountry", newVal);
      }
    },
    phoneAreaCode: {
      get() {
        return this.customer.phoneAreaCode ? this.customer.phoneAreaCode : "";
      },
      set(newVal) {
        this.customer.phoneAreaCode = newVal;
      }
    },
    companies() {
      return this.$anm22["vircos_getCompanies"]();
    },
    channels() {
      return this.$anm22["vircos_getChannels"]();
    }
  },
  methods: {
    selectMainProject(mainProjectId) {
      this.$http
        .post("vircos/selectMainProject", {
          projectId: this.project.idWorldProject,
          mainProjectId: mainProjectId,
        }, {
          withCredentials: true
        })
        .then(response => {
          // Salvo il progetto principale
          if (response.data.mainProject) {
            this.formData.mainProject = response.data.mainProject.projectId;
            this.formData.mainProjectId = response.data.mainProject.id;

            if (response.data.mainProject.customers) {
              this.selectContact(response.data.mainProject.customers[0]);
            }
          }
        })
        .catch(error => {
          /* offline */
        });
    },
    removeMainProject() {
      this.formData.mainProject = null;
    },
    setNewContactMode(field, val) {
      this.customer[field] = val;
      this.newContactMode = true;
      this.$nextTick(() => {
        this.$refs["customer_" + field].focus();
      });
    },
    selectContact(id) {
      this.$http
        .post("vircos/selectContact", {
          projectId: this.project.idWorldProject,
          idContact: id
        }, {
          withCredentials: true
        })
        .then(response => {
          /* Aggiungo il nuovo cliente al progetto */
          let project = { ...this.project };
          project.customers.push(response.data.contact.idContactsContact);
          this.customer = response.data.contact;
          this.address = response.data.place;
          /* Aggiorno il db locale */
          return Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            }),
            this.$store.dispatch("places/update", {
              vlf: this.$vlf("places"),
              objs: [response.data.place]
            })
          ]);
        })
        .then(() => {
          this.saveForm();
        })
        .catch(error => {
          console.log(error);
        });
    },
    /**
     * Questo metodo implementa la gestione custom dei contatti Vircos.
     * Se non è stato ancora associato un customer al progetto (quindi il contatto non è settato)
     * l'operatore può iniziare a scrivere il nome / cognome del contatto all'interno dell'apposito campo
     * di input e il sistema effettua una ricerca all'interno dei contatti per mostrare eventuali riscontri.
     * Se il contatto esiste già è possibile cliccarlo ed automaticamente viene effettuata l'associazione
     * come cliente (di conseguenza viene valorizzato il documento anagrafica del progetto).
     * In caso contrario, viene data la possibilità all'utente di valorizzare tutti i campi in questo form
     * e di salvare il documento. In questo caso avvengono le seguenti operazioni:
     * - Viene creato un nuovo contatto a partire dalle informazioni
     * - Viene associato al progetto come cliente
     * - Viene costruito il documento Vircos completo da associare al progetto
     * - Viene salvato il documento Vircos
     * Il tutto viene fatto con i metodi custom in VircosController che, a loro volta, richiamano
     * i controller di Contacts e di Tasks
     */
    saveContact() {
      if (this.project.customers.length > 0) {
        // Il contatto è già presente, salvo eventuali modifiche e poi salvo il documento di Vircos
        this.$http
          .post("vircos/editContact", {
            projectId: this.project.idWorldProject,
            contact: this.customer,
            address: this.address
          }, {
            withCredentials: true
          })
          .then(response => {
            this.customer = response.data.contact;
            this.address = response.data.place;
            return Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: [response.data.contact]
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: [response.data.place]
              })
            ]);
          })
          .then(result => {
            this.saveForm();
          })
          .catch(error => console.log(error));
      } else {
        this.$http
          .post("vircos/newContact", {
            projectId: this.project.idWorldProject,
            contact: this.customer,
            address: this.address
          }, {
            withCredentials: true
          })
          .then(response => {
            /* Aggiungo il nuovo cliente al progetto */
            let project = { ...this.project };
            project.customers.push(response.data.contact.idContactsContact);
            this.customer = response.data.contact;
            this.address = response.data.place;
            /* Aggiorno il db locale */
            return Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: [response.data.contact]
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: [response.data.place]
              })
            ]);
          })
          .then(result => {
            this.saveForm();
          })
          .catch(error => {
            // Offline
          });
      }
    },
    /*
     * Tutte le informazioni di contatto vengono prese direttamente dal contatto,
     * in fase di salvataggio però vengono copiate anche nel documento custom di vircos
     * in modo da conservarne una copia associata al progetto nel caso in cui il contatto venisse cancellato
     * in futuro.
     */
    updateVircosDoc() {
      this.formData.name = this.customer.firstName;
      this.formData.surname = this.customer.lastName;
      this.formData.address = this.address;
      this.formData.phone = {
        areaCode: this.customer.phoneAreaCode,
        number: this.customer.phoneNumber
      };
      this.formData.email = this.customer.email;
    },
    saveForm() {
      const docs = { ...this.docs };
      this.updateVircosDoc();
      let oldCompany = docs.data.company;
      let oldCompanyName = docs.data.companyName;
      let oldCustomerName = docs.data.name;
      let oldCustomerLastName = docs.data.surname
      docs.data = this.formData;
      docs.data.lastUser = this.user.idWorldUser;
      docs.data.lastUpdate = this.$moment().unix();
      /* Controllo per generazione codice */
      if(this.project.projectId != '') {
        if(this.formData.name != oldCustomerName || this.formData.surname != oldCustomerLastName|| this.formData.company != oldCompany || this.formData.companyName != oldCompanyName) {
          this.$emit("save", docs, true);
        } else {
          this.$emit("save", docs, false);
        }
      } else { 
        this.$emit("save", docs, true);
      }
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    sendWelcomeNotification() {
      if (this.formData.email) {
        this.formData.notificationWelcome = this.$moment().unix();
        this.notificationSended = true;
        this.$http
          .post("vircos/sendWelcomeNotification", {
            projectId: this.project.idWorldProject,
            email: this.formData.email,
            name: this.formData.name,
            surname: this.formData.surname
          }, {
            withCredentials: true
          })
          .then(response => {
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        console.log("Notification: Missing customer e-mail");
      }
    }
  },
  created() {
    /**
     * Vengono creati in copia in modo da gestire correttamente eventuali salvataggi e modifiche
     */
    if (this.project.customers.length > 0) {
      this.customer = {
        ...this.$store.getters["contacts/get"](this.project.customers[0])
      };
    }
    if (
      Object.keys(this.customer).length > 0 &&
      this.customer.places.length > 0
    ) {
      this.address = {
        ...this.$store.getters["places/get"](this.customer.places[0])
      };
    }
    this.formData = { ...this.docs.data };
    if (!this.formData.company) {
      this.formData.company = "rvt";
    }
    if (this.formData.notes && Array.isArray(this.formData.notes)) {
      if (this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[
          this.formData.notes.length - 1
        ].note;
      } else {
        this.formData.notes = "";
      }
    }
    if (this.customer && this.customer.commercialPrivacyPolicyDate) {
      this.formData.commercialPrivacyPolicyDate = 1;
    } else {
      this.formData.commercialPrivacyPolicyDate = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
  min-height: 36px;
}
.input-elem {
  width: 200px;
}
.label-input-radio {
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.selected-main-project {
  div {
    display: inline-block;
    vertical-align: middle;
  }
  img {
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    margin-left: 10px;
  }
}
.vircos-notification-send-btn {
  cursor: pointer;
  position: relative;
  padding: 6px 12px 6px 32px;
  background-color: #eee;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  &:hover {
    background-color: #ddd;
  }

  img {
    position: absolute;
    left: 10px;
    top: 6px;
    width: 16px;
  }
}
.vircos-notification-sended {
  position: relative;
  padding: 6px 12px 6px 22px;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  img {
    position: absolute;
    left: 0px;
    top: 6px;
    width: 16px;
  }
}
@media print {
  .print-row {
    width: 541px !important;
    max-width: 541px !important;
  }
  .company-row {
    width: 220px;
  }

  .row-add {
    width: 500px !important;
  }
  .row-numb {
    width: 235px !important;
  }

  .no-print {
    display: none;
  }
}
</style>
